import { AbstractControl, ValidationErrors } from "@angular/forms";

export function trimmedRequiredValidator(control: AbstractControl): ValidationErrors | null {
    const isValid = control.value?.trim().length > 0;

    return isValid ? null : { required: true };
}
